import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    redirectTo: '/',
    user: {
      authenticated: false,
      token: null,
    },
  },
  mutations: {
    login(state, token, data) {
      state.user.authenticated = true;
      state.user.token = token;
      state.user.data = data;
    },
    logout(state) {
      state.user.authenticated = false;
      state.user.token = null;
      state.user.data = null;
    },
    setRedirection(state, path) {
      state.redirectTo = path;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js